/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var printIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("g", {
        transform: "translate(-1125.000000, -330.000000)",
        fill: "#00A758",
        fillRule: "nonzero",
        children: /*#__PURE__*/jsx("path", {
          d: "M1140.83942,333.956044 L1140.83942,330 L1129.16058,330 L1129.16058,333.956044 L1125,333.956044 L1125,346.263736 L1129.16058,346.263736 L1129.16058,350 L1140.83942,350 L1140.83942,346.263736 L1145,346.263736 L1145,333.956044 L1140.83942,333.956044 Z M1131.35036,332.197802 L1138.64964,332.197802 L1138.64964,333.956044 L1131.35036,333.956044 L1131.35036,332.197802 Z M1138.64964,347.802198 L1131.35036,347.802198 L1131.35036,342.747253 L1138.64964,342.747253 L1138.64964,347.802198 Z M1142.81022,344.065934 L1140.83942,344.065934 L1140.83942,340.549451 L1129.16058,340.549451 L1129.16058,344.065934 L1127.18978,344.065934 L1127.18978,336.153846 L1142.81022,336.153846 L1142.81022,344.065934 Z"
        })
      })
    })]
  });
});

export { printIcon as default };
